module.exports = __webpack_public_path__ + "static/media/21_tn.9cd612a8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/thumbnails/21_tn.jpg
// module id = 509
// module chunks = 0